/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

/* Load kuvr-modal.js / .css if the theme.liquid CDN cache is stale.
   snippets/kuvr-modal-info-cards.liquid normally emits BOTH tags itself; this is only
   the fallback. It used to inject the JS on EVERY page from a hardcoded URL, so on
   pages with no kuvr-modal.css (the homepage, collections, most pages) the script
   still built the modal shell and it rendered unstyled - a 24px white bar plus a
   default-bordered close button at the foot of every page. So: bail out unless this
   page actually uses the modal, and if it does, inject the stylesheet too. */
(function() {
  if (document.querySelector('script[src*="kuvr-modal"]')) return;
  var cssLink = document.querySelector('link[href*="kuvr-modal.css"]');
  if (!cssLink && !document.querySelector('[data-modal-url]')) return;
  var base = cssLink
    ? cssLink.href.replace('kuvr-modal.css', '').replace(/[?].*/, '')
    : '//kuvr.co/cdn/shop/t/9/assets/';
  if (!cssLink) {
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = base + 'kuvr-modal.css';
    document.head.appendChild(l);
  }
  var s = document.createElement('script');
  s.src = base + 'kuvr-modal.js';
  document.head.appendChild(s);
})();

/* ============================================================================= */
/* Make entire measurement row clickable (not just the label text)               */
/* Triggers the same jQuery click DPO uses to open the accordion                 */
(function() {
  function bindMeasRows() {
    document.querySelectorAll('.dpo_len_con').forEach(function(row) {
      if (row.dataset.rowBound) return;
      row.dataset.rowBound = '1';
      row.style.cursor = 'pointer';
      row.addEventListener('click', function(e) {
        if (e.target.closest('.instant-quote-subheading')) return;
        var heading = row.querySelector('.instant-quote-subheading');
        if (heading && window.jQuery) jQuery(heading).trigger('click');
      });
    });
  }
  setTimeout(bindMeasRows, 500);
  setTimeout(bindMeasRows, 1500);
  setTimeout(bindMeasRows, 3000);
  (window.__kuvrDpoShims = window.__kuvrDpoShims || []).push(bindMeasRows);
})();


/* ============================================================================= */
/* Universal: fix label padding in textarea/file-upload fields (further-instructions) */
/* DPO injects base CSS dynamically so !important in stylesheets can't win.       */
/* JS runs after DPO renders, sets inline style which always wins.                */
(function() {
  function fixInstructionsLabel() {
    document.querySelectorAll('#itoris_dynamicproductoptions td.further-instructions label').forEach(function(lbl) {
      /* ⚠️ This used to hardcode padding-left:0 + margin-left:2px. Those numbers
         were fitted to one surface and are wrong on the others — measured
         2026-08-20, the speech-bubble icon sat 11px LEFT of the image-up icon
         directly above it, on BOTH the product page (2px vs 13px) and the cart's
         Update Product modal (26px vs 37px). Hardcoding a second set of numbers
         for the modal only moves the problem, because DPO wraps this label
         differently on each surface.
         So it is measured instead: copy the box metrics of the nearest sibling
         label that carries an icon, then nudge by whatever gap is left between
         the two icons. Self-correcting on any surface, and a no-op once aligned. */
      var ref = null;
      var scope = lbl.closest('.fieldset') || lbl.closest('table') || document;
      var candidates = scope.querySelectorAll('label');
      for (var c = 0; c < candidates.length; c++) {
        if (candidates[c] !== lbl && candidates[c].querySelector('svg') &&
            candidates[c].getBoundingClientRect().width > 0) { ref = candidates[c]; break; }
      }
      var icon = lbl.querySelector('svg');
      var refIcon = ref && ref.querySelector('svg');
      if (!icon || !refIcon) {
        /* nothing to measure against — leave DPO's own value alone */
        return;
      }
      var refStyle = window.getComputedStyle(ref);
      lbl.style.setProperty('padding-left', refStyle.paddingLeft, 'important');
      lbl.style.setProperty('margin-left', refStyle.marginLeft, 'important');
      var delta = refIcon.getBoundingClientRect().left - icon.getBoundingClientRect().left;
      if (Math.abs(delta) > 0.5) {
        var base = parseFloat(refStyle.marginLeft) || 0;
        lbl.style.setProperty('margin-left', (base + delta) + 'px', 'important');
      }
    });
  }
  setTimeout(fixInstructionsLabel, 300);
  setTimeout(fixInstructionsLabel, 800);
  setTimeout(fixInstructionsLabel, 2000);
  (window.__kuvrDpoShims = window.__kuvrDpoShims || []).push(fixInstructionsLabel);
})();


/* ============================================================================= */
/* Screens & Tarpaulins build — DPO field fixes (inline styles beat the app's     */
/* injected <style>; re-asserted on every DPO re-render).                          */
/*   • note textareas (irregular-spacing, split-placement) → full width + readable */
/*     so they match the "Further information" box (which has no .default-message)  */
/*   • measurement diagrams → left padding to match the content inset              */
/*   • PVCArmour material option → hidden on the rabbit hutch product ONLY          */
(function () {
  /* PVCArmour visibility + default are driven by the product's custom.fabric_columns
     metafield (emitted as window.KUVR_FABRICS in layout/theme.liquid) — NOT by the URL.
     A URL check breaks silently the moment a staging build is copied onto the live
     product at cutover, which is exactly how the DPO price engine broke (BUG-026).
       list present and omits pvc-armour -> hide the PVCArmour swatch
       list present and includes it      -> select PVCArmour as the default
       metafield absent                  -> do nothing, leave DPO as configured */
  function kuvrFabrics() {
    var f = window.KUVR_FABRICS;
    /* On the cart page there is no `product`, so fall back to the per-product map and
       resolve it from the product DPO is currently configuring. Without this the
       cart's edit-options modal would show PVCArmour on a clear-screen product. */
    if (!f && window.KUVR_FABRICS_BY_PRODUCT) {
      try {
        var pid = window.dpoOptions && window.dpoOptions.productConfig && window.dpoOptions.productConfig.id;
        if (pid != null) f = window.KUVR_FABRICS_BY_PRODUCT[String(pid)];
      } catch (e) {}
    }
    if (!f) return null;
    var list = Array.isArray(f) ? f : String(f).split(',');
    list = list.map(function (x) { return String(x).trim().toLowerCase(); }).filter(Boolean);
    return list.length ? list : null;
  }
  function pvcIsSold() {
    var l = kuvrFabrics();
    return !!l && l.indexOf('pvc-armour') !== -1;
  }
  function pvcIsHidden() {
    var l = kuvrFabrics();
    return !!l && l.indexOf('pvc-armour') === -1;
  }
  /* Find the PVCArmour swatch by its image alt, the same way the hide has always done. */
  function pvcChoice(panel) {
    var imgs = panel.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (/pvc/i.test(imgs[i].alt || '')) {
        return imgs[i].closest('.field.choice, li, tr, .field');
      }
    }
    return null;
  }
  /* Default-to-PVCArmour runs once, and never overrides a real customer choice:
     any change inside the DPO panel retires it immediately. */
  var pvcDefaultSettled = false;
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('#itoris_dynamicproductoptions')) {
      pvcDefaultSettled = true;
    }
  }, true);
  function fixScreensTarps() {
    var panel = document.getElementById('itoris_dynamicproductoptions');
    if (!panel) return;

    /* Every note textarea EXCEPT the "Further information" one, which is the
       reference: it reaches the 12px inset natively through its field margin.
       This used to read `textarea.default-message`, but DPO drops that class as
       soon as the field has a value — so a note box that the customer had
       actually filled in stopped being normalised. Invisible on a product page,
       where the fields start empty; obvious in the cart's Update Product modal,
       which always renders saved values, and where "Split placement
       instructions" came out 227px wide against the reference box's 548px. */
    panel.querySelectorAll('textarea').forEach(function (ta) {
      /* The "Further information" box used to be skipped entirely and treated as
         the reference the others were matched to, because it reaches the 12px
         inset natively through its field margin. That holds on a product page
         and on a desktop cart modal (measured 36/36 inside a 620px modal) but
         NOT on a narrow one, where it came out 58px from the left and 80px from
         the right. So it is normalised by computation like every other box now,
         which is a no-op wherever the native margins were already right.
         Its LABEL is still left alone — that one is owned by
         fixInstructionsLabel above, which runs first and sets margin-left 2px;
         the 4px below would undo it and step the speech-bubble icon right. */
      var isFurtherInfo = !!ta.closest('td.further-instructions');
      /* Reproduce the "Further information" box exactly: a 12px inset each side of
         the cell, box filling the rest. The reference gets there via a 12px field
         margin; the note fields only have 5px and DPO forces a 100px base width, so
         compute the target width off the containing cell and set it explicitly. */
      var cell = ta.closest('td');
      var cw = cell ? cell.clientWidth : 0;
      var field = ta.closest('.field');
      if (field) { field.style.removeProperty('width'); field.style.setProperty('margin-left', '0', 'important'); field.style.setProperty('margin-right', '0', 'important'); }
      var ctl = ta.closest('.control');
      if (ctl) ctl.style.removeProperty('width');
      if (cw > 40) {
        /* In the cart's Update Product modal every element sits on one 24px
           edge owned by the scroller. A 12px margin set INLINE here beats that
           stylesheet rule, so the note boxes would sit 12px inside everything
           else and stop 12px short on the right. Full cell width, no margin —
           product pages keep the original 12px inset. */
        var inPopup = !!(ta.closest && ta.closest('#itoris_dynamicproductoptions_popup'));
        ta.style.setProperty('box-sizing', 'border-box', 'important');
        ta.style.setProperty('width', (inPopup ? cw : cw - 24) + 'px', 'important');
        ta.style.setProperty('margin-left', inPopup ? '0px' : '12px', 'important');
        ta.style.setProperty('margin-right', inPopup ? '0px' : '12px', 'important');
      }
      ta.style.setProperty('font-size', '14px', 'important');
      ta.style.setProperty('font-style', 'normal', 'important');
      /* align the field's heading label to the box's 12px inset (these are NOT
         td.further-instructions labels, so RULE 3 does not apply here) */
      var wrap = isFurtherInfo ? null : ta.closest('div[id^="dynamic_option_id_"]');
      var lbl = wrap && wrap.querySelector('label');
      /* label already carries 8px padding-left; +4px margin lands its text on the
         box's left edge (1088), not inside it. */
      if (lbl) lbl.style.setProperty('margin-left', '4px', 'important');
    });

    /* Diagram images live in the dimension sections — those are the only sections
       that carry a text/number input. Swatch tiles (shape, material) never do, so
       this leaves them alone. */
    panel.querySelectorAll(':scope > div[id^="fieldset-section-"]').forEach(function (sec) {
      if (!sec.querySelector('input[type="text"], input[type="number"]')) return;
      sec.querySelectorAll('img').forEach(function (img) {
        /* margin, not padding — padding + border-box was shrinking the diagram.
           A small left margin just steps it in from the panel edge. */
        img.style.setProperty('margin-left', '12px', 'important');
      });
    });

    if (pvcIsHidden()) {
      var hideMe = pvcChoice(panel);
      if (hideMe) hideMe.style.setProperty('display', 'none', 'important');
    }

    if (pvcIsSold() && !pvcDefaultSettled) {
      var pc = pvcChoice(panel);
      var radio = pc && pc.querySelector('input[type="radio"]');
      if (radio) {
        pvcDefaultSettled = true;
        if (!radio.checked) radio.click();   /* click, so DPO reveals the colour section */
      }
    }

    /* Unit-of-measure indicator (cm / m / in) next to the dimension inputs. The
       global CSS only draws it for the accordion measurement layout; this build
       uses plain dimension sections, so tag their input controls and let the CSS
       ([unit=...] .kuvr-dim-unit::after) render it. Dimension sections are found
       positionally — everything between the measuring-guide section and the first
       radio step (tie-downs) — so no heading text or placeholder is relied on. */
    var secs = [].slice.call(panel.querySelectorAll(':scope > div[id^="fieldset-section-"]'));
    var measureIdx = -1;
    for (var mi = 0; mi < secs.length; mi++) {
      if (secs[mi].querySelector('a.dpo-open-mg-btn')) { measureIdx = mi; break; }
    }
    if (measureIdx > -1) {
      for (var di = measureIdx + 1; di < secs.length; di++) {
        if (secs[di].querySelector('input[type="radio"]')) break;   /* reached tie-downs */
        secs[di].querySelectorAll('input[type="text"], input[type="number"]').forEach(function (inp) {
          var ctl = inp.closest('.control');
          if (ctl && !ctl.classList.contains('kuvr-dim-unit')) ctl.classList.add('kuvr-dim-unit');
        });
      }
    }
  }
  [400, 1000, 2000, 4000].forEach(function (t) { setTimeout(fixScreensTarps, t); });
  (window.__kuvrDpoShims = window.__kuvrDpoShims || []).push(fixScreensTarps);
  var stQ = false;
  new MutationObserver(function () {
    if (stQ) return; stQ = true;
    setTimeout(function () { stQ = false; fixScreensTarps(); }, 150);
  }).observe(document.documentElement, { subtree: true, childList: true });
})();


/* ============================================================================= */
/* Universal: tiedown swatch images fill grid cells (DPO sets fixed 165px width) */
(function() {
  function fixTiedownSwatches() {
    document.querySelectorAll('.tiedown .itoris-dynamicoptions-thumbnail-image').forEach(function(img) {
      img.style.setProperty('width', '100%', 'important');
      img.style.setProperty('max-width', 'none', 'important');
      img.style.setProperty('height', 'auto', 'important');
    });
    document.querySelectorAll('.tiedown .dpo_swatch').forEach(function(sw) {
      sw.style.setProperty('width', '100%', 'important');
    });
  }
  setTimeout(fixTiedownSwatches, 300);
  setTimeout(fixTiedownSwatches, 800);
  setTimeout(fixTiedownSwatches, 2000);
  (window.__kuvrDpoShims = window.__kuvrDpoShims || []).push(fixTiedownSwatches);
})();















/* ── Custom file upload button ── */
(function() {
  function injectFileButtons() {
    document.querySelectorAll('[id^="dynamic_option_id_"] input[type="file"]').forEach(function(input) {
      if (input.nextElementSibling && input.nextElementSibling.classList.contains('kuvr-file-btn')) return;
      var btn = document.createElement('span');
      btn.className = 'kuvr-file-btn';
      btn.innerHTML = '<span class="kuvr-file-btn__label">Choose File</span>';
      var label = btn.querySelector('.kuvr-file-btn__label');
      btn.addEventListener('click', function(e) {
        if (e.target.classList.contains('kuvr-file-btn__clear')) return;
        input.click();
      });
      input.parentNode.insertBefore(btn, input.nextSibling);
      // Hide DPO native filename display
      var nativeSpan = input.parentNode.querySelector('.dpo_file_name');
      if (nativeSpan) nativeSpan.style.display = 'none';
      input.addEventListener('change', function() {
        var name = input.files && input.files[0] ? input.files[0].name : '';
        if (name) {
          btn.innerHTML = '<span class="kuvr-file-btn__label">' + name + '</span><span class="kuvr-file-btn__clear" title="Remove">×</span>';
          btn.querySelector('.kuvr-file-btn__clear').addEventListener('click', function(e) {
            e.stopPropagation();
            input.value = '';
            btn.innerHTML = '<span class="kuvr-file-btn__label">Choose File</span>';
          });
        } else {
          btn.innerHTML = '<span class="kuvr-file-btn__label">Choose File</span>';
        }
      });
      // Also observe DPO native span appearing later
      var observer = new MutationObserver(function() {
        var ns = input.parentNode.querySelector('.dpo_file_name');
        if (ns) ns.style.display = 'none';
      });
      observer.observe(input.parentNode, {childList: true, subtree: true});
    });
  }
  setTimeout(injectFileButtons, 2000);
  setTimeout(injectFileButtons, 4000);
  (window.__kuvrDpoShims = window.__kuvrDpoShims || []).push(injectFileButtons);
})();


/* ============================================================================= */
/* Instant Quote — numbered step headings (design 1b)                            */
/*                                                                                */
/* Tags the DPO app's top-level sections and their titles so custom.css can draw   */
/* a teal "STEP n" eyebrow above each section title.                               */
/*                                                                                */
/* ⚠️ RULE: NEVER identify a section by its heading TEXT. The wording is editable   */
/* in the Itoris template and changing it must not break anything here. Sections    */
/* are identified structurally (what controls they contain, where they sit), and    */
/* where structure isn't enough, by an explicit data-kuvr hook in the template.     */
/*                                                                                */
/* The number is a CSS counter, not JS — a section hidden for a given product       */
/* (display:none) is skipped automatically and the numbering re-flows.              */
/*                                                                                */
/* Conditional sub-options (Material colour, Eyelet spacing, Zip / Velcro qty) are  */
/* NOT steps — they belong inside the step that revealed them. They are excluded    */
/* structurally: they are hidden at first paint, and only sections present at first  */
/* paint can become steps.                                                          */
(function () {
  var NS = 'http://www.w3.org/2000/svg';

  /* ── Icons (Lucide 1.28, 24x24, 2px stroke, round caps/joins) ──
     Keys are the values accepted by the data-kuvr hook, below. */
  var ICONS = {
    ruler: ['M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z', 'm14.5 12.5 2-2', 'm11.5 9.5 2-2', 'm8.5 6.5 2-2', 'm17.5 15.5 2-2'],
    dimension: ['M10 15v-3', 'M14 15v-3', 'M18 15v-3', 'M2 8V4', 'M22 6H2', 'M22 8V4', 'M6 15v-3', 'M4 12h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2z'],
    shapes: ['M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z', 'M4 14h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1z', 'M21 17.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z'],
    swatch: ['M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z', 'M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7', 'M7 17h.01', 'm11 8 2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8'],
    link: ['M9 17H7A5 5 0 0 1 7 7h2', 'M15 7h2a5 5 0 1 1 0 10h-2', 'M8 12h8'],
    puzzle: ['M15.39 4.39a1 1 0 0 0 1.68-.474 2.5 2.5 0 1 1 3.014 3.015 1 1 0 0 0-.474 1.68l1.683 1.682a2.414 2.414 0 0 1 0 3.414L19.61 15.39a1 1 0 0 1-1.68-.474 2.5 2.5 0 1 0-3.014 3.015 1 1 0 0 1 .474 1.68l-1.683 1.682a2.414 2.414 0 0 1-3.414 0L8.61 19.61a1 1 0 0 0-1.68.474 2.5 2.5 0 1 1-3.014-3.015 1 1 0 0 0 .474-1.68l-1.683-1.682a2.414 2.414 0 0 1 0-3.414L4.39 8.61a1 1 0 0 1 1.68.474 2.5 2.5 0 1 0 3.014-3.015 1 1 0 0 1-.474-1.68l1.683-1.682a2.414 2.414 0 0 1 3.414 0z'],
    paperclip: ['m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551'],
    imageUp: ['M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21', 'm14 19.5 3-3 3 3', 'M17 22v-5.5', 'M9 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0-4 0'],
    messageText: ['M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z', 'M7 11h10', 'M7 15h6', 'M7 7h8'],
    /* grommet/eyelet — a ring with a hole (outer r10, inner r3) */
    grommet: ['M22 12a10 10 0 1 1-20 0 10 10 0 1 1 20 0Z', 'M15 12a3 3 0 1 1-6 0 3 3 0 1 1 6 0Z'],
    /* turn button — ellipse (per Duncan): ellipse cx12 cy12 rx10 ry6 as a path */
    stud: ['M22 12a10 6 0 1 1-20 0 10 6 0 1 1 20 0Z'],
    /* split — Lucide split (the Splits step) */
    split: ['M16 3h5v5', 'M8 3H3v5', 'M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3', 'm15 9 6-6'],
    /* square-split-horizontal (per Duncan) — velcro/zip strip quantity subheadings */
    splitH: ['M8 19H5c-1 0-2-1-2-2V7c0-1 1-2 2-2h3', 'M16 5h3c1 0 2 1 2 2v10c0 1-1 2-2 2h-3', 'M12 4v16']
  };

  function makeIcon(name) {
    if (!ICONS[name]) return null;
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'dpo-icon');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    ICONS[name].forEach(function (d) {
      var p = document.createElementNS(NS, 'path');
      p.setAttribute('d', d);
      svg.appendChild(p);
    });
    return svg;
  }

  /* Idempotent: bails out if OUR icon of that name is already in place, so it can
     be re-asserted on every pass without the write re-triggering the observer. */
  function setIcon(title, name) {
    if (!ICONS[name]) return;                          /* unknown key — leave well alone */
    var old = title.querySelector('svg.dpo-icon');
    if (old && old.getAttribute('data-kuvr-icon') === name) return;
    var svg = makeIcon(name);
    svg.setAttribute('data-kuvr-icon', name);
    if (old) old.parentNode.replaceChild(svg, old);
    else title.insertBefore(svg, title.firstChild);
  }

  /* ── Structural helpers. None of these look at heading text. ── */

  function isAccordionHeader(f) {
    return f.classList.contains('heading') || !!f.querySelector('.dpo_len_con');
  }

  function isAccordionBody(f) {
    var prev = f.previousElementSibling;
    return !!(prev && prev.classList && prev.classList.contains('heading'));
  }

  /* An explicit hook the Itoris template can set, e.g.
       <p class="instant-quote-subheading" data-kuvr="fabric"> … </p>
     Accepted values are the ICONS keys above, plus "none" to suppress the swap.
     This is the ONLY way to tell Fabric type from Fasteners — they are identical
     in structure — so without it those two keep whatever icon the app renders. */
  function hookIcon(fieldset, title) {
    if (title && title.getAttribute('data-kuvr')) return title.getAttribute('data-kuvr');
    if (fieldset.getAttribute('data-kuvr')) return fieldset.getAttribute('data-kuvr');
    var el = fieldset.querySelector('[data-kuvr]');
    return el ? el.getAttribute('data-kuvr') : null;
  }

  function headingOf(fieldset) {
    /* <p> only — the length accordion reuses .instant-quote-subheading on a <span>. */
    return fieldset.querySelector('p.instant-quote-subheading');
  }

  /* visibleAtLoad: the section was rendered (not display:none) on the first pass.
     Conditional sub-options are hidden then, which is how they are excluded. */
  function classify(fieldset, visibleAtLoad) {
    if (isAccordionHeader(fieldset) || isAccordionBody(fieldset)) return null;

    /* Extras block — the one holding the file input / free-text box.
       Never numbered. Identified by its controls, never by what it is called. */
    if (fieldset.querySelector('input[type="file"], textarea')) {
      var eh = headingOf(fieldset);
      return eh ? { key: 'extras', numbered: false, icon: 'paperclip', title: eh } : null;
    }

    /* Panel header section — carries the Instant Quote title; its field label is
       the unit-of-measure control. */
    if (fieldset.querySelector('h3.instant-quote-title')) {
      var ul = fieldset.querySelector('label.required');
      return ul ? { key: 'unit', numbered: true, icon: 'ruler', title: ul } : null;
    }

    /* Measurements — the section carrying the measuring-guide button. */
    if (fieldset.querySelector('a.dpo-open-mg-btn')) {
      var ctl = fieldset.querySelector('div.control');
      var mp = ctl ? ctl.querySelector('p') : null;
      return mp ? { key: 'measure', numbered: true, icon: 'dimension', title: mp } : null;
    }

    /* Tie-downs — the app marks that cell .tiedown. */
    var h = headingOf(fieldset);
    if (h && fieldset.querySelector('td.tiedown')) {
      return { key: 'tiedown', numbered: true, icon: 'link', title: h };
    }

    /* Any other authored heading is a step. Fabric type and Fasteners are
       byte-identical in structure, so which is which is resolved by POSITION
       relative to tie-downs afterwards (see assignNeighbourIcons) — never by text. */
    if (h) return { key: 'step', numbered: true, icon: null, title: h };

    /* Shape / unit pickers have no authored heading, just a field label — but unlike
       the conditional sub-options they are present at first paint. A real picker
       carries a selectable control (radio or swatch). Dimension boxes (Length A/B,
       Diameter) and the eyelet/turn QUANTITY boxes also carry a required label but
       are text-input only — they are the BODY of the step above (measurements, or the
       quantity heading), not steps in their own right. Requiring a radio/swatch keeps
       them out of the step count, so Length A reads like Length B and Qty A like Qty B. */
    if (visibleAtLoad) {
      var sl = fieldset.querySelector('label.required');
      if (sl && fieldset.querySelector('input[type="radio"], .dpo_swatch')) {
        /* Only the FIRST swatch section is the numbered shape step. A SECOND
           swatch section (garden furniture's conditional "Bench Shape") is a
           refinement of the shape already chosen — a sub-option, never a step.
           Without this guard it only escaped numbering by being hidden at first
           paint; when DPO restored a saved selection on reload it was visible,
           classified as a second shape step, took the measurements reserve and
           rendered as "STEP 4" with Step 3 nowhere (Duncan, 2026-08-21).
           DOM order guarantees the real shape section classifies first. */
        var pnl = fieldset.closest('#itoris_dynamicproductoptions');
        if (pnl && pnl.querySelector('.kuvr-iq-sect--shape')) return null;
        return { key: 'shape', numbered: true, icon: 'shapes', title: sl };
      }
    }

    return null;
  }

  /* Re-locate a section's title element from its stored kind. The DPO app
     re-renders option HTML after load (price recalculation), which destroys the
     node we originally tagged — so nothing may hold a reference to it. */
  function findTitle(fieldset, key) {
    if (key === 'unit' || key === 'shape') return fieldset.querySelector('label.required');
    if (key === 'measure') {
      var ctl = fieldset.querySelector('div.control');
      return ctl ? ctl.querySelector('p') : null;
    }
    return headingOf(fieldset);
  }

  /* Sub-fields inside the extras block, matched by the control they label. */
  function tagSubtitles(fieldset) {
    fieldset.querySelectorAll('div[id^="dynamic_option_id_"]').forEach(function (d) {
      var lab = d.querySelector(':scope > label');
      if (!lab || lab.classList.contains('kuvr-iq-title')) return;
      var icon = d.querySelector('input[type="file"]') ? 'imageUp'
               : d.querySelector('textarea') ? 'messageText'
               : null;
      if (!icon) return;
      lab.classList.add('kuvr-iq-subtitle');
      setIcon(lab, icon);
      /* ⚠️ DO NOT touch padding-left / margin-left on these labels. The
         `td.further-instructions label { padding-left:0; margin-left:2px }` fix
         higher up this file was hard-won; an inline override here silently
         undoes it. Type styling only. */
    });
  }

  /* The app config leaves empty placeholder options at the top of some sections.
     They render as a ~34px blank row and throw the rhythm out. */
  function collapseSpacers(fieldset) {
    fieldset.querySelectorAll('div[id^="dynamic_option_id_"]').forEach(function (d) {
      if (d.textContent.trim() !== '') return;
      if (d.querySelector('input, select, textarea, img, svg, button, a')) return;
      var tr = d.closest('tr');
      if (tr) tr.style.setProperty('display', 'none', 'important');
    });
  }

  var firstPassDone = false;

  var taggedPanel = null;
  function tag() {
    var panel = document.getElementById('itoris_dynamicproductoptions');
    if (!panel) return false;
    /* ⚠️ firstPassDone is what makes `visibleAtLoad` meaningful, and it was a
       once-per-PAGE flag. The cart's Update Product modal builds a brand new
       #itoris_dynamicproductoptions every time it opens, so from the SECOND
       open onwards visibleAtLoad was already false, classify() returned null
       for the shape section, and that section silently lost its step number,
       its eyebrow, its icon and its divider — "STEP 2 / Outdoor Kitchen Shape"
       rendered as a bare teal label. Reproduced 2026-08-20: first open tagged
       six titles, second open tagged none.
       Reset only when the panel node itself has been replaced AND it lives in
       the cart popup, so the product page keeps the original once-per-page
       behaviour that stops a revealed conditional section being promoted to a
       numbered step mid-session. */
    if (panel !== taggedPanel) {
      taggedPanel = panel;
      if (panel.closest && panel.closest('#itoris_dynamicproductoptions_popup')) firstPassDone = false;
    }
    var sections = panel.querySelectorAll(':scope > div[id^="fieldset-section-"]');
    if (!sections.length) return false;

    /* Wait for a fully rendered panel before the first pass — the visible-at-load
       test is what excludes conditional sub-options, so a half-built DOM would
       misclassify. The extras block is the last thing to render. */
    if (!firstPassDone && !panel.querySelector('input[type="file"], textarea')) return false;

    sections.forEach(function (f) {
      if (f.dataset.kuvrIq) return;
      var visibleAtLoad = !firstPassDone && getComputedStyle(f).display !== 'none';
      var hit = classify(f, visibleAtLoad);
      if (!hit) return;

      f.dataset.kuvrIq = hit.key;
      f.classList.add('kuvr-iq-sect', 'kuvr-iq-sect--' + hit.key);
      if (hit.numbered) f.classList.add('kuvr-iq-step');

      var title = hit.title;
      title.classList.add('kuvr-iq-title');

      var icon = hookIcon(f, title) || hit.icon;
      if (icon) f.dataset.kuvrIcon = icon;
      if (hit.numbered) f.dataset.kuvrNum = '1';
      if (icon && icon !== 'none') setIcon(title, icon);

      if (hit.numbered && !(title.previousElementSibling &&
          title.previousElementSibling.classList.contains('kuvr-iq-eyebrow'))) {
        var eb = document.createElement('span');
        eb.className = 'kuvr-iq-eyebrow';
        eb.setAttribute('aria-hidden', 'true');
        title.parentNode.insertBefore(eb, title);
      }

      collapseSpacers(f);
      if (hit.key === 'extras') tagSubtitles(f);
    });

    firstPassDone = true;
    return true;
  }

  /* On shape-led products the measurements section stays hidden until a shape is
     chosen. Without this, every step below it would shift up by one and then back
     down again mid-configuration. Reserve the slot instead. */
  function reserveMeasureSlot() {
    var panel = document.getElementById('itoris_dynamicproductoptions');
    var shape = panel && panel.querySelector('.kuvr-iq-sect--shape');
    if (!shape) return;

    /* Mark the step that would otherwise take Measurements' number. */
    if (!panel.querySelector('.kuvr-iq-reserve')) {
      var n = shape.nextElementSibling;
      while (n) {
        if (n.classList.contains('kuvr-iq-step') &&
            !n.classList.contains('kuvr-iq-sect--measure')) {
          n.classList.add('kuvr-iq-reserve');
          break;
        }
        n = n.nextElementSibling;
      }
    }

    var visible = [].some.call(
      panel.querySelectorAll('.kuvr-iq-sect--measure'),
      function (m) { return m.offsetParent !== null; }
    );
    panel.classList.toggle('kuvr-iq--await-measure', !visible);
  }

  /* Fabric type and Fasteners cannot be told apart structurally — same markup,
     same controls. They ARE distinguishable by where they sit: the configuration
     order is fabric → tie-downs → fasteners, and tie-downs is identifiable by its
     .tiedown cell. So take the nearest generic step before tie-downs as fabric and
     the nearest one after as fasteners. Positional, not textual: rename either
     heading to anything you like and this still holds. A data-kuvr attribute on
     the heading overrides it. */
  function assignNeighbourIcons() {
    var panel = document.getElementById('itoris_dynamicproductoptions');
    if (!panel) return;
    var td = panel.querySelector('.kuvr-iq-sect--tiedown');
    if (!td) return;

    function walk(from, dir, icon) {
      var n = from[dir];
      while (n) {
        if (n.dataset && n.dataset.kuvrIq === 'step') {
          if (n.dataset.kuvrIcon !== icon) n.dataset.kuvrIcon = icon;
          return;                       /* reassert() draws it, and redraws it */
        }
        n = n[dir];
      }
    }
    walk(td, 'previousElementSibling', 'swatch');
    walk(td, 'nextElementSibling', 'puzzle');
  }

  /* The length accordion already draws its own 2px rule under the last row, so a
     step sitting directly beneath it would get two lines doing the same job.
     Decided from the preceding VISIBLE sibling, so it stays correct on shape-led
     products where the accordion only appears once a shape is chosen. */
  function updateRules() {
    document.querySelectorAll('#itoris_dynamicproductoptions .kuvr-iq-sect').forEach(function (s) {
      var prev = s.previousElementSibling;
      while (prev && prev.offsetParent === null) prev = prev.previousElementSibling;
      var afterAccordion = !!(prev && (isAccordionHeader(prev) || isAccordionBody(prev)));
      s.classList.toggle('kuvr-iq-no-rule', afterAccordion);
    });
  }

  /* Re-assert everything on every pass. The DPO app re-renders option HTML after
     load (price recalculation), which throws away the classes, the eyebrow span
     and the icon we injected — while the section wrapper, and therefore its
     data-kuvr-iq tag, survives. Without this the styling silently reverts a
     moment after the page settles. All writes are no-ops when already correct,
     so this does not feed the MutationObserver. */
  function reassert() {
    document.querySelectorAll('#itoris_dynamicproductoptions [data-kuvr-iq]').forEach(function (f) {
      var title = findTitle(f, f.dataset.kuvrIq);
      if (!title) return;

      if (!title.classList.contains('kuvr-iq-title')) title.classList.add('kuvr-iq-title');

      var icon = hookIcon(f, title) || f.dataset.kuvrIcon;
      if (icon && icon !== 'none') setIcon(title, icon);

      if (f.dataset.kuvrNum &&
          !(title.previousElementSibling &&
            title.previousElementSibling.classList.contains('kuvr-iq-eyebrow'))) {
        var eb = document.createElement('span');
        eb.className = 'kuvr-iq-eyebrow';
        eb.setAttribute('aria-hidden', 'true');
        title.parentNode.insertBefore(eb, title);
      }

      collapseSpacers(f);
      if (f.dataset.kuvrIq === 'extras') tagSubtitles(f);
    });
  }

  /* The .tiedown cell is added by the app when it renders that section's swatches,
     which can be AFTER our first classification pass. If it wasn't there yet, that
     section was typed as a generic 'step' — which also means Fabric type and
     Fasteners never got resolved, since they are positioned relative to it.
     Re-check on every pass and upgrade as soon as the cell appears. */
  function upgradeTiedown() {
    var panel = document.getElementById('itoris_dynamicproductoptions');
    if (!panel || panel.querySelector('.kuvr-iq-sect--tiedown')) return;
    var late = panel.querySelector('[data-kuvr-iq="step"] td.tiedown');
    if (!late) return;
    var f = late.closest('[data-kuvr-iq]');
    f.dataset.kuvrIq = 'tiedown';
    f.classList.remove('kuvr-iq-sect--step');
    f.classList.add('kuvr-iq-sect--tiedown');
    f.dataset.kuvrIcon = 'link';
    /* neighbours were never assigned (or assigned off the wrong anchor) — redo */
    panel.querySelectorAll('[data-kuvr-iq="step"]').forEach(function (n) {
      delete n.dataset.kuvrIcon;
    });
  }

  /* Icon assignment for the Screens & Tarpaulins build. Several sections here are
     byte-identical in structure (a radio + a heading), so — exactly like the
     Fabric-vs-Fasteners case the positional logic can't resolve — they cannot be
     told apart structurally. The sanctioned override is a data-kuvr hook on the
     heading; where the template doesn't carry one, fall back to a keyword on the
     heading text. This is COSMETIC ONLY (icon glyph). It never affects numbering
     or section identity, and it only fills sections that have no icon yet, so a
     heading rename at worst drops an icon (harmless), never breaks layout. */
  var KW_ICONS = [
    [/tie.?down/i, 'link'],
    [/eyelet/i, 'grommet'],
    [/grommet/i, 'grommet'],
    [/turn.?button/i, 'stud'],
    [/split/i, 'split'],
    [/fabric|material/i, 'swatch']
  ];
  function assignKeywordIcons() {
    var panel = document.getElementById('itoris_dynamicproductoptions');
    if (!panel) return;
    panel.querySelectorAll('[data-kuvr-iq="step"]').forEach(function (f) {
      if (f.dataset.kuvrIcon) return;                 /* already resolved — leave it */
      var t = findTitle(f, 'step');
      if (!t) return;
      var txt = t.textContent || '';
      for (var i = 0; i < KW_ICONS.length; i++) {
        if (KW_ICONS[i][0].test(txt)) { f.dataset.kuvrIcon = KW_ICONS[i][1]; break; }
      }
    });
  }

  /* Promote the descriptive labels in the CONDITIONAL sub-option sections
     (irregular-spacing note, split-placement note, velcro/zip quantity) to black
     subheadings-with-icon, so the hierarchy matches the "Further information"
     block's subheadings. Identified structurally, never by text:
       • a textarea field OUTSIDE the extras block  → messageText (a note)
       • a radio field that shares its section with a textarea → the split sub-options
     Re-asserted every pass (the app rebuilds option HTML — RULE 2). */
  function tagSubheads() {
    var panel = document.getElementById('itoris_dynamicproductoptions');
    if (!panel) return;
    panel.querySelectorAll(':scope > div[id^="fieldset-section-"]').forEach(function (sec) {
      if (sec.dataset.kuvrIq) return;                         /* stepped / extras — handled elsewhere */
      if (sec.querySelector('input[type="file"]')) return;    /* the extras block */
      var hasTextarea = !!sec.querySelector('textarea');
      sec.querySelectorAll('div[id^="dynamic_option_id_"]').forEach(function (d) {
        var lab = d.querySelector(':scope > label');
        if (!lab) return;
        var icon = d.querySelector('textarea') ? 'messageText'
                 : (hasTextarea && d.querySelector('input[type="radio"]')) ? 'splitH'
                 : null;
        if (!icon) return;
        if (!lab.classList.contains('kuvr-iq-subhead')) lab.classList.add('kuvr-iq-subhead');
        setIcon(lab, icon);
      });
    });
  }

  function run() {
    if (!tag()) return;
    upgradeTiedown();
    assignNeighbourIcons();
    assignKeywordIcons();
    reassert();
    tagSubheads();
    reserveMeasureSlot();
    updateRules();
  }

  [200, 500, 900, 1500, 2500, 4000, 6000].forEach(function (t) { setTimeout(run, t); });

  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; run(); }, 120);
  }).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'class']
  });
})();


/* ============================================================================= */
/* Product-page "How it works" — scroll-linked step thread                        */
/* The section markup lives in the how-ordering-works PAGE body and is injected   */
/* into product pages by the kuvr-ajax-loader via innerHTML. Scripts inside       */
/* injected HTML do NOT execute, so the driver has to live here in the theme.     */
/*                                                                                */
/* PROGRESS IS DRIVEN BY SCROLL POSITION, NOT A TIMER (changed 2026-08-07).        */
/* The fill is empty when the step list's top edge sits ENTER% down the viewport   */
/* and full when its bottom edge reaches EXIT%, so it completes with the whole     */
/* section still on screen. Because progress is a pure function of position it     */
/* reverses for free when the customer scrolls back up — there is no playback      */
/* state to unwind, and no reset/replay cycle. Do not reintroduce a timer.         */
/*                                                                                */
/* The dots do NOT use hardcoded percentages. Each paint measures the fill's       */
/* ACTUAL leading edge and lights a dot the moment that edge passes the dot's      */
/* measured centre, so the pops land on true intersection at any width or font     */
/* size. Do not "simplify" this back to percentages; earlier versions drifted.     */
(function () {
  window.__kuvrHiwDriver = 'loaded';

  /* Progress window, as a fraction of viewport height.
     ENTER: fill starts as the list's top edge rises above this line.
     EXIT:  fill is complete as the list's bottom edge reaches this line.
     EXIT was 0.50 and finished too late — dot 04 only lit once the top of the
     list had gone under the sticky header. At 0.75 the line completes with the
     whole section still sitting comfortably on screen. Retune here and nowhere
     else; everything downstream is derived. */
  var ENTER = 0.80, EXIT = 0.75;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lit = new WeakMap();
  var queued = false;
  var started = false;
  var mo = null;

  /* Dot centre in the thread's own coordinates, from offsetTop/offsetLeft (2026-10-19).
     getBoundingClientRect includes CSS transforms, and every lit dot plays hiwHit, which
     lifts it up to 8px. A re-snap or a lit-test taken mid-bounce measured the dot up to
     8px high, so the rail could end above dot 4's true centre and dot 4 then never lit
     again ("step 4 doesn't fill after scrolling back and forth", Duncan). Offsets ignore
     transforms, so the geometry is the dot's resting position whatever it is doing. */
  function centreIn(d, group, vert) {
    var o = 0, e = d;
    while (e && e !== group) { o += vert ? e.offsetTop : e.offsetLeft; e = e.offsetParent; }
    if (e !== group) {
      var r = d.getBoundingClientRect(), g = group.getBoundingClientRect();
      return vert ? r.top - g.top - group.clientTop + r.height / 2 : r.left - g.left - group.clientLeft + r.width / 2;
    }
    return o + (vert ? d.offsetHeight : d.offsetWidth) / 2;
  }

  /* Pure function of the list's position in the viewport — no stored playhead. */
  function progressFor(group) {
    /* Reduced motion: render the finished state rather than a permanently empty rail. */
    if (reduce) return 1;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    if (!vh) return 0;
    var r = group.getBoundingClientRect();
    var span = (ENTER - EXIT) * vh + r.height;   /* > 0 for any sane layout */
    if (span <= 0) return 0;
    var p = (ENTER * vh - r.top) / span;
    return p < 0 ? 0 : (p > 1 ? 1 : p);
  }

  function paint() {
    queued = false;
    var root = document.getElementById('kuvr-phiw');
    if (!root) return;

    root.querySelectorAll('[data-fill]').forEach(function (fill) {
      var vert = fill.getAttribute('data-fill') === 'v';
      var group = fill.closest('[data-thread]');
      if (!group) return;
      var dots = Array.prototype.slice.call(group.querySelectorAll('[data-dot]'));

      /* Snap the rail to the dots on BOTH axes: vertically it runs from dot 1's
         centre to the last dot's centre, horizontally it is centred on the dots'
         centre line. The horizontal snap matters because the rail is absolutely
         positioned and therefore offset from the thread's padding box, while the
         dots are flex children that start AFTER any padding — so any left padding
         picked up from the theme at a given breakpoint slides the dots right and
         leaves the rail behind. That is what broke alignment on mobile. Measure,
         never hardcode: the CSS `left` is only a pre-paint fallback. */
      if (vert && !fill._snapped && dots.length >= 2) {
        if (dots[0].offsetHeight && dots[0].offsetWidth) {
          var aC = centreIn(dots[0], group, true), bC = centreIn(dots[dots.length - 1], group, true);
          var track = fill.parentElement;
          var rw = track.offsetWidth || 5;
          track.style.top = aC + 'px';
          track.style.bottom = 'auto';
          track.style.height = (bC - aC) + 'px';
          track.style.left = (centreIn(dots[0], group, false) - rw / 2) + 'px';
          track.style.right = 'auto';
          fill._snapped = true;
        }
      }

      var shown = progressFor(group);

      /* No transition: the fill must sit exactly where the scroll puts it, with no
         lag or overshoot when the customer scrubs quickly or changes direction. */
      fill.style.transition = 'none';
      fill.style.opacity = '1';
      fill.style.clipPath = vert
        ? 'inset(0 0 ' + ((1 - shown) * 100).toFixed(3) + '% 0)'
        : 'inset(0 ' + ((1 - shown) * 100).toFixed(3) + '% 0 0)';

      if (!dots.length) return;
      /* clip-path does not alter getBoundingClientRect, so the rect is the FULL rail
         and the leading edge has to be derived from it. Hence the shown > 0 guard
         below: at shown === 0 the computed front sits exactly on dot 1's centre. */
      /* Thread coordinates, transform-free (see centreIn). The track is the fill's parent
         and never animates, so its offsets are exact. */
      var trk = fill.parentElement;
      var tLen = vert ? trk.offsetHeight : trk.offsetWidth;
      var front = centreIn(trk, group, vert) - tLen / 2 + tLen * shown;
      dots.forEach(function (d) {
        var c = centreIn(d, group, vert);
        /* 0.5px tolerance: at shown === 1 the front sits exactly on the last dot's centre. */
        var on = shown > 0 && front >= c - 0.5;
        if (lit.get(d) === on) return;
        lit.set(d, on);
        if (on) {
          d.style.background = '#f1605f'; d.style.borderColor = '#f1605f'; d.style.color = '#fff';
          if (!reduce) { d.style.animation = 'none'; void d.offsetWidth; d.style.animation = 'hiwHit .5s ease-out'; }
        } else {
          d.style.animation = 'none';
          d.style.background = '#fff'; d.style.borderColor = '#cfdcda'; d.style.color = '#006f6c';
        }
      });
    });
  }

  /* One paint per frame at most, however many events land in between. */
  function request() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(paint);
  }

  function unsnap() {
    var root = document.getElementById('kuvr-phiw');
    if (root) root.querySelectorAll('[data-fill]').forEach(function (f) { f._snapped = false; });
  }

  var rt;
  function onResize() {
    request();
    clearTimeout(rt);
    rt = setTimeout(function () { unsnap(); request(); }, 150);
  }

  function start() {
    if (started) return;
    if (!document.getElementById('kuvr-phiw')) return;
    started = true;
    window.__kuvrHiwDriver = 'started';
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    request();
    /* Layout settles late — webfonts, the poster image, the AJAX injection itself.
       Re-snap and repaint a few times so the rail lands on the final dot centres. */
    [100, 400, 1000, 2500].forEach(function (ms) {
      setTimeout(function () { unsnap(); request(); }, ms);
    });
  }

  /* Escape closes the video lightbox. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var lb = document.getElementById('hiwVideoLightbox');
    if (!lb || !lb.classList.contains('is-active')) return;
    var fr = document.getElementById('hiwVideoFrame');
    lb.classList.remove('is-active');
    if (fr) fr.src = '';
    document.body.style.overflow = '';
  });

  /* The section arrives via AJAX, so wait for it — and if the app re-renders and
     swaps the markout out, re-snap against the new nodes. childList only: paint()
     writes styles, so watching attributes here would feed the observer its own
     output and spin a permanent rAF loop. */
  mo = new MutationObserver(function () {
    if (!started) { start(); return; }
    unsnap();
    request();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  [300, 900, 2000, 4000].forEach(function (ms) { setTimeout(start, ms); });
})();

/* ============================================================================
   Kuvr zero-price guard  —  v2, 2026-08-17
   ----------------------------------------------------------------------------
   WHY IT LIVES HERE AND NOT IN THE DPO GLOBAL JS:
   v1 was put in the DPO global JavaScript. That field is APP-level, not
   theme-level, so it executed on the LIVE Narrative theme too. It silently
   blocked add-to-basket on live made-to-measure products for ~18 hours on
   2026-08-16/17 (configure, click, button greys, nothing happens, no order).
   assets/custom.js is theme-scoped: live Narrative has its own 834-byte
   custom.js from March, so nothing here can reach the live site. It becomes
   active only when Ella is published — by which point the engine does run.
   🛑 DO NOT MOVE THIS INTO THE DPO GLOBAL CSS/JS FIELDS.

   WHAT v1 GOT WRONG, LOGICALLY:
   it treated "finalPrice is not a positive number" as broken. But undefined
   means the formula engine never ran, which is the normal state on a theme
   where it is not wired in. "Never calculated" must mean DO NOTHING.

   WHAT IT CAN AND CANNOT CATCH:
   catches  — engine ran and produced 0 (the BUG-026 failure: every config £0)
   misses   — engine ran and produced a WRONG non-zero figure (e.g. only the
              split add-on priced). Partial mispricing is not detectable here.
   Set KUVR_PRICE_GUARD = false below to disable instantly without a code edit.
   ============================================================================ */
(function () {
  var KUVR_PRICE_GUARD = true;
  var MSG = 'We could not calculate a price for this configuration. Please contact us and we will sort it out.';

  function calculatedPrice() {
    try {
      var F = window.PriceFormula;
      if (!F || !F.formulas || !F.formulas.length) return null;  /* no engine on this product */
      var p = F.finalPrice;
      if (typeof p !== 'number' || !isFinite(p)) return null;    /* NEVER CALCULATED -> null */
      return p;
    } catch (e) { return null; }
  }

  function shouldBlock() {
    if (!KUVR_PRICE_GUARD) return false;
    var p = calculatedPrice();
    if (p === null) return false;      /* the case that caused the live outage */
    return p <= 0;                     /* a real calculation that came out at zero */
  }

  function wrap(name) {
    try {
      var o = window.dpoOptions;
      if (!o || typeof o[name] !== 'function' || o[name].__kuvrGuarded) return;
      var orig = o[name];
      var wrapped = function () {
        if (shouldBlock()) {
          try { console.error('[kuvr-price-guard] engine calculated ' +
            (window.PriceFormula && window.PriceFormula.finalPrice) + ' — add to cart blocked'); } catch (e) {}
          try { alert(MSG); } catch (e) {}
          try {
            var els = document.querySelectorAll('.submitting');
            for (var i = 0; i < els.length; i++) els[i].classList.remove('submitting');
            var b = document.getElementById('itoris_dynamicoptions_add_to_cart');
            if (b) { b.disabled = false; b.removeAttribute('disabled'); }
          } catch (e) {}
          return false;
        }
        return orig.apply(this, arguments);
      };
      wrapped.__kuvrGuarded = true;
      o[name] = wrapped;
    } catch (e) {}
  }

  var n = 0, t = setInterval(function () {
    if (++n > 60) { clearInterval(t); return; }
    if (!window.dpoOptions || !window.dpoOptions.isInit) return;
    clearInterval(t);
    wrap('addToCart');
    wrap('buyNow');
  }, 500);
})();


/* =============================================================================
   Newsletter popup: gate Ella's timer behind a real intent trigger.

   Ella only exposes "Delay Time (Seconds)" and "Show Again After (Days)". A pure time
   delay fires while the visitor is still reading the hero, and it collides with the
   HelpScout Beacon and the Loox toast - three overlays on one pageview. There is no
   exit-intent, scroll or page-exclusion setting in the theme, so it is built here.

   How it works: Ella's <newsletter-popup> element captures its own setTimeout at
   construction time, so that timer cannot be cancelled from outside. Instead we watch
   <body> and strip `newsletter-show` every time Ella adds it, until one of our own
   triggers fires - exit intent, 50% scroll depth, or 30s dwell, whichever comes first.

   Ella's own dismissal cookie is respected untouched, so "Show Again After (Days)"
   still controls the frequency cap. Never fires on cart, checkout or account.

   window.__kuvrPopupGate exposes live state for debugging.
   Kill switch: window.KUVR_POPUP_GATE = false restores Ella's stock behaviour.
   ============================================================================= */
(function () {
  function init() {
    var state = { installed: false, reason: '', opened: false, trigger: null };
    window.__kuvrPopupGate = state;

    if (window.KUVR_POPUP_GATE === false) { state.reason = 'kill switch'; return; }

    var body = document.body;
    if (!body) { state.reason = 'no body'; return; }

    function dismissed() { return /(^|;\s*)newsletter-popup=/.test(document.cookie); }
    if (dismissed()) { state.reason = 'already dismissed'; return; }

    var DWELL_MS  = 30000;
    var SCROLL_AT = 0.5;
    var BLOCKED   = /^\/(cart|checkout|account)(\/|$)/.test(location.pathname);

    var obs = new MutationObserver(function () {
      if (!state.opened && body.classList.contains('newsletter-show')) {
        body.classList.remove('newsletter-show');
        body.classList.remove('show-newsletter-image');
      }
    });
    obs.observe(body, { attributes: true, attributeFilter: ['class'] });
    state.installed = true;

    if (BLOCKED) { state.reason = 'blocked page - gate held open-ended'; return; }

    var timer = null;

    function teardown() {
      if (timer) clearTimeout(timer);
      document.removeEventListener('mouseout', onExit);
      window.removeEventListener('scroll', onScroll);
    }

    function open(why) {
      if (state.opened) return;
      state.opened = true;
      state.trigger = why;
      obs.disconnect();
      teardown();
      if (dismissed()) { state.reason = 'dismissed before trigger'; return; }
      if (!document.querySelector('[data-newsletter-popup]')) { state.reason = 'no popup element'; return; }
      body.classList.add('newsletter-show');
      setTimeout(function () { body.classList.add('show-newsletter-image'); }, 700);
    }

    function onExit(e) { if (!e.relatedTarget && e.clientY <= 0) open('exit-intent'); }

    function onScroll() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && (window.scrollY / max) >= SCROLL_AT) open('scroll');
    }

    timer = setTimeout(function () { open('dwell'); }, DWELL_MS);
    document.addEventListener('mouseout', onExit);
    window.addEventListener('scroll', onScroll, { passive: true });
    state.open = open;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ============================================================================= */
/* Re-run the DPO shims for the cart's "Update Product" modal.                    */
/*                                                                                */
/* Every shim above is scheduled off page-load timers. The modal is injected by    */
/* the Itoris app long after those have fired, so none of them had ever run for    */
/* it. That single fact was behind four separate "bugs" reported on 2026-08-20:    */
/*   • the speech-bubble label stepped 8px right   (fixInstructionsLabel)          */
/*   • no upload button, and the attachment already on the line invisible          */
/*                                                  (injectFileButtons)            */
/*   • the PVCArmour swatch showing on a clear-only product   (fixScreensTarps)    */
/*   • note textareas rendering narrow and off-margin          (fixScreensTarps)   */
/*                                                                                */
/* Deliberately gated on the popup existing, so product pages keep exactly the     */
/* behaviour they had — they are already covered by their own timers and by        */
/* fixScreensTarps's own observer. Every registered shim is idempotent (each       */
/* guards on the state it creates), so re-running is safe.                         */
(function () {
  if (!window.MutationObserver) return;
  var queued = false;
  function runShims() {
    var fns = window.__kuvrDpoShims || [];
    for (var i = 0; i < fns.length; i++) {
      try { fns[i](); } catch (e) { /* one bad shim must not stop the rest */ }
    }
  }
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      if (document.getElementById('itoris_dynamicproductoptions_popup')) runShims();
    }, 150);
  }).observe(document.documentElement, { subtree: true, childList: true });
})();


/* ============================================================================= */
/* Instant Quote — measurement diagram on the product image (desktop)             */
/*                                                                                */
/* Focus a measurement field and the diagram for THAT measurement is mirrored     */
/* large over the product photo, so the customer sees what they're measuring at   */
/* full size, not just the thumbnail beside the field.                            */
/*                                                                                */
/* NO NEW DATA. DPO already renders a per-letter, per-shape diagram inside each   */
/* length field's own section (e.g. okc_grillsink_a.png). We mirror that image —  */
/* which means shapes, two-level sub-shapes (garden furniture Bench/Corner Sofa)  */
/* and every future product work with zero configuration: if the field has a      */
/* diagram beside it, it has one on the photo.                                    */
/*                                                                                */
/* ⚠️ RULES: the field is found by STRUCTURE (a text input inside a DPO section),  */
/* never by label text; the diagram is found by BEING a raster image in that same  */
/* section (arrows and letter badges are .svg), never by filename or by index.     */
/* The predecessor of this feature — DPO per-product JS on the Adirondack test     */
/* product — used jQuery :contains("Length") and .productView-thumbnail.eq(1),     */
/* both of which break on a label rename or an image reorder. Do not reintroduce.  */
/*                                                                                */
/* Desktop only (>=1025px): on mobile the gallery sits above the config panel and  */
/* is off-screen while measuring — and the field's own diagram is right there.     */
/* Latches: stays until another measurement field is focused, so tabbing between   */
/* fields doesn't flicker back to the photo. Close button restores the photo.      */
(function () {
  var MQ = window.matchMedia('(min-width: 1025px)');
  var OVERLAY_ID = 'kuvr-mdiag';

  function panel() { return document.getElementById('itoris_dynamicproductoptions'); }
  function stage() { return document.querySelector('.productView-image'); }

  /* The diagram DPO renders in a length field's own section. Structural: a raster
     image of drawing size — the arrow chevrons and A/B/C letter badges are .svg. */
  function diagramIn(section) {
    /* VISIBLE drawing first (2026-10-19, rattan). Compact multi-shape configs keep one help block
       per shape inside each letter's section and hide all but the selected shape's. Taking the
       first raster in the section picked the FIRST shape's drawing (L-shape sofa) for every other
       shape: Sofa Chair / Recliner showed the sofa's B, C, D on the stage. Fall back to the first
       raster only when nothing is visible (sections with a single drawing behave exactly as before). */
    var imgs = section.querySelectorAll('img'), first = null;
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      var src = (im.currentSrc || im.getAttribute('src') || '').split('?')[0];
      if (!src || /\.svg$/i.test(src)) continue;
      if (im.naturalWidth && im.naturalWidth < 200) continue;
      if (im.getClientRects().length) return im;
      if (!first) first = im;
    }
    return first;
  }

  function ensureOverlay() {
    var st = stage(); if (!st) return null;
    var el = document.getElementById(OVERLAY_ID);
    if (el && el.parentNode === st) return el;
    if (el && el.parentNode) el.parentNode.removeChild(el);
    el = document.createElement('div');
    el.id = OVERLAY_ID;
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<button type="button" class="kuvr-mdiag__close" aria-label="Back to product photo">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"></path></svg>' +
      '</button>' +
      '<div class="kuvr-mdiag__body"><img alt=""><div class="kuvr-mdiag__cap"><strong></strong><span></span></div></div>';
    st.appendChild(el);
    el.querySelector('.kuvr-mdiag__close').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); hide();
    });
    return el;
  }

  function showImage(srcImg, title, note, altSuffix) {
    if (!srcImg) return;
    showUrl(srcImg.currentSrc || srcImg.src, title, note, altSuffix, null, 'letter');
  }

  /* The accordion header (LENGTH x) that owns this body section, or null.
     THE GATE for the whole stage feature: only the NEW per-letter accordion layout
     drives it. The legacy products (Clear Kuvr Custom, Custom Tarpaulins Made To
     Measure, Custom Rabbit Hutch Covers, and the un-migrated shapes inside Garden
     Furniture) put every length field in ONE flat section with no .dpo_len_con at all
     — flat screens with two or three measurements that don't need this.
     🛑 Why the gate exists: on those products the Trapezium shape — and only Trapezium
     — ships trap-a.gif / trap-b.gif / trap-c.gif beside its fields. GIFs are rasters, so
     they passed diagramIn()'s "is this a drawing" test where every other legacy shape
     uses .svg and was correctly ignored. All three inputs share one section, so A, B and
     C all resolved to trap-a.gif: the stage lit up on Length A and then appeared dead.
     Gating on the accordion silences every legacy product structurally — and means the
     stage switches itself ON automatically as each product is migrated to the new
     layout, with no handle list to maintain. */
  function accordionHeadFor(section) {
    var p = section && section.previousElementSibling;
    while (p && !(p.id && p.id.indexOf('fieldset-section-') === 0)) p = p.previousElementSibling;
    return (p && p.querySelector('.dpo_len_con')) ? p : null;
  }

  /* Swapping between diagrams dips the drawing and its caption out and back — 90ms
     each way, so it reads as a soft blink rather than a hard cut. Image AND caption
     move together (the class goes on .kuvr-mdiag__body) so the label never changes
     under a still-visible drawing.
     swapToken guards a fast click-through: only the newest swap may reveal, so an
     earlier image that finishes decoding late can't flash up over a newer one. */
  var swapToken = 0;

  function showUrl(url, title, note, altSuffix, headroom, kind) {
    if (!MQ.matches || !url) return;
    var el = ensureOverlay(); if (!el) return;
    /* Per-shape headroom override, or clear it. ALWAYS one or the other: the letter
       diagrams call showUrl with no headroom, and without the clear a shape's override
       would leak onto every letter diagram shown after it. */
    if (headroom) el.setAttribute('data-mdiag-headroom', headroom);
    else el.removeAttribute('data-mdiag-headroom');
    /* Letter drawing (A, B, C...) or shape guide. fitHeight caps letter drawings separately. */
    el.setAttribute('data-mdiag-kind', kind === 'letter' ? 'letter' : 'guide');
    var img = el.querySelector('img');
    var body = el.querySelector('.kuvr-mdiag__body');
    var wasShowing = el.classList.contains('is-on');

    el.classList.add('is-on');
    el.setAttribute('aria-hidden', 'false');

    if (img.getAttribute('src') === url) { body.classList.remove('is-swapping'); return; }

    var mine = ++swapToken;
    var apply = function () {
      if (mine !== swapToken) return;
      img.style.width = '';
      img.setAttribute('src', url);
      scaleTo(img);
      img.alt = title ? title + ' — ' + altSuffix : altSuffix;
      el.querySelector('.kuvr-mdiag__cap strong').textContent = title || '';
      el.querySelector('.kuvr-mdiag__cap span').textContent = note || '';
      var reveal = function () { if (mine === swapToken) body.classList.remove('is-swapping'); };
      if (img.complete && img.naturalWidth) { reveal(); return; }
      img.addEventListener('load', function onl() { img.removeEventListener('load', onl); reveal(); }, { once: true });
      img.addEventListener('error', function one() { img.removeEventListener('error', one); reveal(); }, { once: true });
    };

    /* Only dip when there is something on screen to dip FROM — the first diagram of a
       session rides the overlay's own fade-in and shouldn't wait an extra 90ms. */
    if (wasShowing && img.getAttribute('src')) {
      body.classList.add('is-swapping');
      setTimeout(apply, 90);
    } else {
      body.classList.remove('is-swapping');
      apply();
    }
  }

  function show(section) {
    var srcImg = diagramIn(section); if (!srcImg) return;
    var lab = section.querySelector('label');
    var note = section.querySelector('.note');
    showImage(srcImg,
      lab ? lab.textContent.replace(/\*/g, '').trim() : '',
      note ? note.textContent.trim() : '',
      'measurement diagram');
  }

  /* A shape picker, structurally: a swatch field with NO authored heading.
     Fabric type, Tie-downs and Fasteners all carry a p.instant-quote-subheading;
     the shape pickers (top level AND the conditional second level — garden
     furniture's Bench Shape / Corner Sofa Shape) carry only a field label. Same
     test classify() uses in the step shim, so the two stay in agreement, and it
     keeps big tie-down photos and fabric swatches OUT of the stage.
     Requested by John via Duncan, 2026-08-21: seeing the chosen shape large,
     before any measuring starts. */
  function isShapePicker(section) {
    return !!section && !section.querySelector('p.instant-quote-subheading');
  }

  /* Shopify prefixes the DPO copy of an image with dpo_custom_option_<id>_ — strip it
     so the same artwork joins across the two systems. */
  function baseOf(url) {
    return (url || '').split('?')[0].split('/').pop().toLowerCase()
             .replace(/^dpo_custom_option_\d+_/, '');
  }

  /* The FULL measuring guide for this shape (every letter on one drawing), taken from
     the measuring-guide section's own data hooks. Joined on image filename first, shape
     name second. Returns null when the product has no guide for that shape — the caller
     then falls back to the swatch artwork, so nothing ever breaks. */
  function guideForSwatch(swatch, im) {
    var thumbs = document.querySelectorAll('#kuvr-mg-thumbs .kuvr-mg__thumb[data-diagram]');
    if (!thumbs.length) return null;
    var key = baseOf(im && (im.currentSrc || im.src));
    var lab = swatch.querySelector('label');
    var name = lab ? lab.textContent.trim().toLowerCase() : '';
    var byName = null;
    for (var i = 0; i < thumbs.length; i++) {
      var t = thumbs[i];
      /* Returns {url, headroom} — headroom is the optional per-shape override for
         fitHeight's clamp (data-mdiag-headroom, emitted by the guide snippet). */
      if (key && baseOf(t.getAttribute('data-thumb')) === key) return { url: t.getAttribute('data-diagram'), headroom: t.getAttribute('data-mdiag-headroom') };
      /* Name join also accepts the swatch's plural: a top-level swatch with no sub-shapes is
         labelled "Office Chairs" / "Rocking Chairs" while its guide is "Office Chair" /
         "Rocking Chair" — without this those two showed no guide at all (Duncan, 2026-10-06). */
      var dn = (t.getAttribute('data-name') || '').trim().toLowerCase();
      if (name && (dn === name || dn === name.replace(/s$/, ''))) byName = { url: t.getAttribute('data-diagram'), headroom: t.getAttribute('data-mdiag-headroom') };
    }
    return byName;
  }

  function showSwatch(swatch) {
    var sec = swatch.closest('div[id^="fieldset-section-"]');
    if (!isShapePicker(sec)) return;
    var im = swatch.querySelector('img'); if (!im) return;
    var lab = swatch.querySelector('label');
    var fieldLab = sec.querySelector('label.required, label');
    var title = lab ? lab.textContent.trim() : '';
    var note = fieldLab ? fieldLab.textContent.replace(/\*/g, '').trim() : '';
    /* Prefer the full measuring guide (John, 2026-08-21) — a bigger copy of the plain
       swatch tells the customer nothing they can't already see. */
    var guide = guideForSwatch(swatch, im);
    if (guide && guide.url) { showUrl(guide.url, title, note, 'measuring guide', guide.headroom); return; }
    /* No guide for this shape — CLEAR the stage, don't just leave it. Switching from an
       L-shape sofa (mid-measure) to Cube used to leave the sofa's Length D diagram
       sitting there, describing furniture the customer is no longer configuring
       (Duncan, 2026-08-21). hide() is a no-op when the photo is already showing, so the
       top-level-category case still behaves: pick "Chairs & Benches", photo stays. */
    hide();
  }

  /* Drawn at naturalWidth x --kuvr-mdiag-scale. The sources are ~500px masters
     (no larger rendition exists on the CDN — the URL carries no size suffix), so
     any scale above 1 is a genuine upscale of line art.

     🛑 THE SCALE IS 1, AND THIS COMMENT USED TO SAY OTHERWISE (BP-021). It claimed
     "1.5 was chosen with Duncan as the point where it fills the stage" while
     custom.css shipped `--kuvr-mdiag-scale: 1`. The CSS was right and the comment
     was stale — a leftover from a proposal that was not taken. Anyone reading the
     comment would have "restored" 1.5 and softened every drawing on the site.

     It is also now clearly the wrong lever. Width was never the binding constraint:
     every source is 500px wide and the stage is ~968px. HEIGHT is what binds, and
     since 2026-08-24 fitHeight() scales tall drawings DOWN to fit the window. The
     tall Adirondack set (500x1050, 500x1008, 500x935) is already being reduced, so
     raising this scale would be immediately undone by the height cap.

     Tune live from the console, no deploy needed:
       document.documentElement.style.setProperty('--kuvr-mdiag-scale','1.25')
     then click a different LENGTH row. For tall drawings reach for
     --kuvr-mdiag-headroom instead; this knob only moves the short, wide ones. */

  /* How much vertical room the drawing actually has. Two separate ceilings, and the
     drawing must clear BOTH.

     🛑 WHY THIS EXISTS. max-width:100% capped the WIDTH only, and every source is
     500px wide, so width was never the constraint — height was, and nothing capped
     it. The Adirondack ottoman set runs 500x1050 (A), 500x1008 (H), 500x935 (F);
     chair-only A is 500x776. The overlay centres its body, so a drawing taller than
     the stage overflowed EQUALLY ABOVE AND BELOW, and the half above went up behind
     the sticky header and off the top of the window — taking the arrow and the
     letter badge with it, which is the only part that says what is being measured.
     Measured on a 1440x900 window: the 500x1050 diagram sat 534px above the stage
     and 277px above the top of the viewport. Duncan, 2026-08-24: "so tall, in fact,
     that they're expanding beyond the screen at the top, which means users cannot
     actually see what the measurement relates to."

     Ceiling 1 — the stage box, less its own 24px padding, the caption, and the gap.
     Ceiling 2 — a screenful, less the sticky header. The stage box can be TALLER
     than a short laptop window, so a drawing that fits the box can still run off
     the top of the screen. Measured from the header group rather than hardcoded, so
     it follows the announcement bar being dismissed or a header setting changing.

     Deliberately NOT recomputed on scroll. Sizing off the currently-visible slice
     would make the drawing breathe as the customer scrolls the accordion, which is
     worse than being a little conservative. Resize is handled, scroll is not. */
  function fitHeight(el) {
    var cap = el.querySelector('.kuvr-mdiag__cap');
    /* 48 = the overlay's 24px padding top and bottom; 14 = .kuvr-mdiag__body gap.
       Both live in custom.css — change them there and change them here. */
    var chrome = 48 + 14 + (cap ? cap.offsetHeight : 0);
    var head = 0;
    var hs = document.querySelectorAll('.shopify-section-group-header-group');
    for (var i = 0; i < hs.length; i++) {
      var cs = getComputedStyle(hs[i]);
      if (cs.position === 'sticky' || cs.position === 'fixed') head += hs[i].offsetHeight;
    }
    /* Breathing room. The first version of this fix computed the LARGEST size that
       technically fits, which is not the same as a size that looks composed — the
       drawing ran from just under the header to the bottom edge of the window with
       about 50px of slack in the whole stack. Duncan, 2026-08-24: "they're still
       really, absolutely maximum height." Fitting and sitting comfortably are two
       different targets, and this is the difference between them.
       Tunable live, no deploy, same as --kuvr-mdiag-scale:
         document.documentElement.style.setProperty('--kuvr-mdiag-headroom','160px')
       then click a different LENGTH row. */
    /* A per-shape override on the overlay wins over the :root value. Set from the
       shape's mdiag_headroom key in custom.measuring_guide — see the guide snippet. */
    var breathe = parseFloat(el.getAttribute('data-mdiag-headroom'));
    if (isNaN(breathe)) breathe = parseFloat(getComputedStyle(document.documentElement)
                    .getPropertyValue('--kuvr-mdiag-headroom'));
    if (isNaN(breathe) || breathe < 0) breathe = 120;
    /* Treat it as a MAXIMUM, not a constant. A flat 120px is comfortable on a tall
       window and punitive on a short one — on a 760px laptop it was taking the 500x1050
       diagram down to 182px wide, trading one unusable extreme for another. Breathing
       room is a share of the window, so it is also capped as a percentage of the height.
       Both knobs are live-tunable; raise the cap first if the px value stops biting:
         document.documentElement.style.setProperty('--kuvr-mdiag-headroom-max','18%') */
    var cap = parseFloat(getComputedStyle(document.documentElement)
                .getPropertyValue('--kuvr-mdiag-headroom-max'));
    if (isNaN(cap) || cap <= 0) cap = 12;
    breathe = Math.min(breathe, Math.round(window.innerHeight * (cap / 100)));
    var box = el.clientHeight - chrome;
    /* Breathing room comes off the SCREENFUL only, not the box. The box ceiling is
       about not escaping the stage; the screenful ceiling is about how it feels to
       look at. Inside the stage, edge to edge is fine. */
    var screenful = window.innerHeight - head - chrome - breathe;
    /* Floor at 200: if the stage has not laid out yet clientHeight can read tiny, and
       a 20px-wide chair helps nobody. Better slightly too big for one frame than a
       drawing shrunk to nothing. */
    /* LETTER DRAWINGS get their own ceiling (2026-10-19, Duncan: stacking-chair letters "way too big").
       They lost their size limit on 2026-10-06 when the 380px/38% headroom was cut to 120px/12% for the
       guides; per-shape mdiag_headroom only reaches guides. On a 1289px-high window the 500x946 stack
       letters drew at 812px tall and ran up under the sticky header. Cap = a share of the window height,
       guides unaffected. Live-tunable: document.documentElement.style.setProperty('--kuvr-mdiag-letter-max','45') */
    var fit = Math.min(box, screenful);
    if (el.getAttribute('data-mdiag-kind') === 'letter') {
      var lm = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--kuvr-mdiag-letter-max'));
      if (isNaN(lm) || lm <= 0) lm = 50;
      fit = Math.min(fit, Math.round(window.innerHeight * (lm / 100)));
    }
    return Math.max(200, fit);
  }

  function scaleTo(img) {
    /* 🛑 Gate on .complete, NOT naturalWidth alone. Assigning a new src leaves the
       PREVIOUS bitmap in place until the new one decodes, so naturalWidth keeps
       reporting the OLD image's dimensions — non-zero, so the old check sailed past
       and sized the new image from the wrong number. Coming from a 1000px guide to a
       500px letter diagram that drew it at 200%. Duncan: "sometimes way bigger than
       100%... can't figure out why". .complete is false from the moment src is set
       until the new image is actually ready. The deferred pass re-checks the src is
       still the one we asked for, so a fast click-through can't apply a stale width. */
    if (!img.complete || !img.naturalWidth) {
      var want = img.getAttribute('src');
      img.addEventListener('load', function onl() {
        img.removeEventListener('load', onl);
        if (img.getAttribute('src') === want) scaleTo(img);
      }, { once: true });
      return;
    }
    var s = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--kuvr-mdiag-scale'));
    if (!s || s <= 0) s = 1;
    var w = img.naturalWidth * s;
    var h = img.naturalHeight * s;
    var el = img.closest ? img.closest('#' + OVERLAY_ID) : null;
    if (el) {
      var avail = fitHeight(el);
      /* Shrink on the DIAGONAL — scale the width by the same factor the height needs,
         so the drawing keeps its proportions. Setting max-height instead would clamp
         the height against a fixed inline width and squash the chair. */
      if (h > avail) w = w * (avail / h);
    }
    img.style.width = Math.round(w) + 'px';
  }

  /* A window resize changes both ceilings. Re-measure the drawing that is on screen —
     scaleTo reads naturalWidth, so re-running it recovers full size when the window
     grows again rather than leaving it stuck at whatever the smallest window forced. */
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var el = document.getElementById(OVERLAY_ID);
      if (!el || !el.classList.contains('is-on')) return;
      var img = el.querySelector('img');
      if (img && img.getAttribute('src')) scaleTo(img);
    }, 120);
  });

  function hide() {
    var el = document.getElementById(OVERLAY_ID);
    if (!el) return;
    swapToken++;                       /* cancel any pending swap reveal */
    el.classList.remove('is-on');
    el.setAttribute('aria-hidden', 'true');
    var body = el.querySelector('.kuvr-mdiag__body');
    if (body) body.classList.remove('is-swapping');
  }

  /* Delegated — the DPO app rebuilds its option HTML after load (price recalc),
     so nothing may hold a reference to a field or listen on it directly. */
  document.addEventListener('focusin', function (e) {
    var p = panel(); if (!p || !p.contains(e.target)) return;
    var t = e.target;
    if (!t.matches || !t.matches('input[type="text"]')) return;
    var sec = t.closest('div[id^="fieldset-section-"]');
    if (sec && accordionHeadFor(sec)) show(sec);
  });

  /* Shape chosen -> show that shape large. Delegated on change so it fires for
     keyboard selection too, and survives the DPO app rebuilding its option HTML. */
  document.addEventListener('change', function (e) {
    var p = panel(); if (!p || !p.contains(e.target)) return;
    var t = e.target;
    if (!t.matches || !t.matches('input[type="radio"], input[type="checkbox"]')) return;
    if (!t.checked) return;
    var sw = t.closest('.dpo_swatch');
    if (sw) showSwatch(sw);
  });

  /* Clicking the LENGTH x accordion ROW swaps the stage — one click earlier than
     focusing the input (John, 2026-08-21). The header section carries .dpo_len_con;
     its body (the input + that letter's diagram) is the next section along. focusin
     stays as well, so keyboard tabbing between fields still tracks. */
  document.addEventListener('click', function (e) {
    var p = panel(); if (!p || !p.contains(e.target)) return;
    if (!e.target.closest) return;
    var head = e.target.closest('.dpo_len_con');
    if (!head) return;
    var sec = head.closest('div[id^="fieldset-section-"]');
    var body = sec && sec.nextElementSibling;
    while (body && !(body.id && body.id.indexOf('fieldset-section-') === 0)) body = body.nextElementSibling;
    if (body) show(body);
  });

  function onMQ() { if (!MQ.matches) hide(); }
  if (MQ.addEventListener) MQ.addEventListener('change', onMQ);
  else if (MQ.addListener) MQ.addListener(onMQ);
})();

/* ---- DPO false "required field" errors on 0 values ----
   Added 2026-08-25, reworked 2026-08-31 to remove the visible red flash.
   DPO's server treats a submitted "0" as empty and returns
   "Please fill in all required fields (Length X)" even though the cart holds
   the 0 correctly and the price calculates fine.

   Approach: hide every .dpo-error the moment it exists, then reveal only the
   ones whose field is NOT actually 0 - so a genuinely blank field still warns.
   FAIL-OPEN: if the cart lookup has not answered within 3s, everything is
   revealed, so a real error can never be permanently swallowed.

   Lives here, not in DPO Global JS - Global JS does not execute on the cart page.
   Delete this whole block if Itoris fix the server-side check. */
(function () {
  if (!/\/cart/.test(location.pathname)) return;

  var css = document.createElement('style');
  css.id = 'kuvr-dpo-error-gate';
  css.textContent = '.dpo-error{visibility:hidden !important}';
  document.head.appendChild(css);

  function revealAll() {
    var s = document.getElementById('kuvr-dpo-error-gate');
    if (s) s.parentNode.removeChild(s);
  }
  var failOpen = setTimeout(revealAll, 3000);

  if (typeof jQuery === 'undefined') { clearTimeout(failOpen); revealAll(); return; }

  jQuery(function () {
    var tries = 0;
    var timer = setInterval(function () {
      if (++tries > 20) { clearInterval(timer); return; }
      var errs = jQuery('.dpo-error');
      if (!errs.length) return;
      clearInterval(timer);
      jQuery.getJSON('/cart.js')
        .done(function (cart) {
          errs.each(function () {
            var m = jQuery(this).text().match(/\(([^)]+)\)\s*$/);
            var keep = true;
            if (m) {
              var field = m[1];
              keep = !cart.items.some(function (it) {
                return it.properties && String(it.properties[field]) === '0';
              });
            }
            if (keep) jQuery(this).css('visibility', 'visible');
            else jQuery(this).remove();
          });
          if (!jQuery('.dpo-error').length) jQuery('body').removeClass('has_cart_errors');
          clearTimeout(failOpen);
          revealAll();
        })
        .fail(function () { clearTimeout(failOpen); revealAll(); });
    }, 250);
  });
})();
